// noinspection JSUnusedGlobalSymbols

export default class
{
	static type(radio)
	{
		switch(radio.value)
		{
			case 'daily' :
				$('#year').removeClass('hidden')
				$('#month').removeClass('hidden')
				$('#day').addClass('hidden')
			break

			case 'monthly' :
				$('#year').removeClass('hidden')
				$('#month').addClass('hidden')
				$('#day').addClass('hidden')
			break

			case 'yearly' :
				$('#year').addClass('hidden')
				$('#month').addClass('hidden')
				$('#day').addClass('hidden')
			break

			case 'staff' :
			case 'shop' :
				$('#year').removeClass('hidden')
				$('#month').removeClass('hidden')
				$('#day').removeClass('hidden')
			break
		}
	}
}
